import React from 'react';
import { Card, Form, } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import './User.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useHistory } from 'react-router-dom';
import useAuth from '../Login/useAuth';
import { EmailOutlined, HomeOutlined, InsertDriveFileOutlined, NfcOutlined, PhoneMissedOutlined } from '@material-ui/icons';
import Navigation from '../Navigation';
// import bg from '../../img/user.jpg'
import swal from 'sweetalert';

const User = () => {

    const history = useHistory()
    const { user, loading } = useAuth()
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = data => {
        fetch('https://thawing-ridge-28572.herokuapp.com/users', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(data => {
                if (data.insertedId) {
                    swal('succesFull Added User')
                    history.push('/adduser')
                }
            })
    }
    AOS.init();

    return (

        <>
            <Navigation></Navigation>
            <div className=" unique text-dark d-flex justify-content-center align-items-center">
                <div className='container d-flex justify-content-center align-items-center 
            shadow-sm  bg-body rounded
            '>
                    <hr />
                    <div className="row ba d-flex justify-content-center align-items-center">
                        <div className="col-md-6  text-start d-flex justify-content-center align-items-center">
                            <Card style={{ width: '30rem' }} className=' p-3 '>
                                <form


                                    className='w-100 h-50 mx-auto  ' onSubmit={handleSubmit(onSubmit)}>
                                    <Form
                                        data-aos="fade-down"
                                        data-aos-easing="linear"
                                        data-aos-duration="1500"
                                        className=' mx-auto text-start fst-normal p-1'>

                                        {user?.displayName ? <Form.Group className="mb-1 " controlId="formGroupEmail">
                                            <Form.Label className=''>Your Name
                                                <InsertDriveFileOutlined className='text-dark ms-2 fs-3'></InsertDriveFileOutlined>

                                            </Form.Label>
                                            <Form.Control readOnly defaultValue={user.displayName} {...register("name")} placeholder="Enter Name" />
                                        </Form.Group> : <Form.Group className="mb-1 " controlId="formGroupEmail">
                                            <Form.Label >  Your Name

                                                <InsertDriveFileOutlined className='text-dark ms-2 fs-3'></InsertDriveFileOutlined>

                                            </Form.Label>
                                            <Form.Control defaultValue={user.displayName} {...register("name")} placeholder="Enter Name" />
                                        </Form.Group>}
                                        {user?.email ? <Form.Group className="mb-1" controlId="formGroupEmail">
                                            <Form.Label>Email address
                                                <EmailOutlined className='text-dark ms-2 fs-3'></EmailOutlined>

                                            </Form.Label>
                                            <Form.Control readOnly defaultValue={user?.email}  {...register("email")} placeholder="Enter email" />
                                        </Form.Group> : <Form.Group className="mb-1" controlId="formGroupEmail">
                                            <Form.Label>Email address
                                                <EmailOutlined className='text-dark ms-2 fs-3'></EmailOutlined>
                                            </Form.Label>
                                            <Form.Control defaultValue={user?.email}  {...register("email")} placeholder="Enter email" />
                                        </Form.Group>}
                                        <Form.Group className="mb-1" controlId="formGroupPassword">
                                            <Form.Label>Phone Number
                                                <PhoneMissedOutlined className='text-dark ms-2 fs-3'></PhoneMissedOutlined>

                                            </Form.Label>
                                            <Form.Control {...register("number", { required: true })} placeholder=" Enter number" />
                                        </Form.Group>
                                        <Form.Group className="mb-1" controlId="formGroupPassword">
                                            <Form.Label>Address
                                                <HomeOutlined className='text-dark ms-2 fs-3'></HomeOutlined>
                                            </Form.Label>
                                            <Form.Control {...register("address", { required: true })} placeholder="Enter Address" />
                                        </Form.Group>
                                        <Form.Group className="mb-1" controlId="formGroupPassword">
                                            <Form.Label>Profession

                                                <NfcOutlined className='text-dark ms-2 fs-3'></NfcOutlined>
                                            </Form.Label>
                                            <Form.Control {...register("relegion", { required: true })} placeholder="Enter occupation" />
                                        </Form.Group>
                                    </Form>
                                    {errors.exampleRequired && <span>This field is required</span>}

                                    <button type="submit" className='text-dark  btn btn-outline-primary btn-lg ms-2'>Submit</button>


                                </form>
                            </Card>
                        </div>

                    </div>

                </div>
            </div>
        </>
    );
};

export default User;